import VeteranLevel0 from 'products/global/assets/img/nest/veteran/level0.png';
import VeteranLevel1 from 'products/global/assets/img/nest/veteran/level1.png';
import VeteranLevel2 from 'products/global/assets/img/nest/veteran/level2.png';
import VeteranLevel3 from 'products/global/assets/img/nest/veteran/level3.png';
import VeteranLevel4 from 'products/global/assets/img/nest/veteran/level4.png';
import VeteranLevel5 from 'products/global/assets/img/nest/veteran/level5.png';
import AltruistLevel0 from 'products/global/assets/img/nest/altruist/level0.png';
import AltruistLevel1 from 'products/global/assets/img/nest/altruist/level1.png';
import AltruistLevel2 from 'products/global/assets/img/nest/altruist/level2.png';
import AltruistLevel3 from 'products/global/assets/img/nest/altruist/level3.png';
import AltruistLevel4 from 'products/global/assets/img/nest/altruist/level4.png';
import AltruistLevel5 from 'products/global/assets/img/nest/altruist/level5.png';
import ContributorLevel0 from 'products/global/assets/img/nest/contributor/level0.png';
import ContributorLevel1 from 'products/global/assets/img/nest/contributor/level1.png';
import ContributorLevel2 from 'products/global/assets/img/nest/contributor/level2.png';
import ContributorLevel3 from 'products/global/assets/img/nest/contributor/level3.png';
import ContributorLevel4 from 'products/global/assets/img/nest/contributor/level4.png';
import SolidEgg from 'products/global/assets/img/nest/egg-solid.png';

export const NEST_ITEM_NAMES = {
  VETERAN: 'VETERAN',
  CONTRIBUTOR: 'CONTRIBUTOR',
  ALTRUIST: 'ALTRUIST',
  UNKNOWN: 'UNKNOWN'
};

export const NEST_ITEM_TEXT = {
  VETERAN: {
    title: 'Veteran',
    levelUpTip:
      'Grow your Veteran bird by being a loyal customer of SafetyWing. Reward: gift cards you can give to friends.'
  },
  CONTRIBUTOR: {
    title: 'Contributor',
    levelUpTip:
      'Thank you for being a SafetyWing Contributor! Grow your bird: We will soon release a new 10 minute survey you can respond to grow your bird and earn a premium black out SafetyWing sleeping mask shipped to your address. As a SafetyWing Contributor, you will receive an email when this is ready.'
  },
  CONTRIBUTOR_LEVEL_ZERO: {
    title: 'Contributor',
    levelUpTip:
      'Hatch your Contributor bird by contributing to SafetyWing. The more surveys you respond to, the more your bird will grow, and you can earn SafetyWing merchandise. Thank you!'
  },
  ALTRUIST: {
    title: 'Altruist',
    levelUpTip:
      'Grow your Altruist bird by giving away gift cards. Earn gift cards by being a loyal customer of SafetyWing.'
  },
  UNKNOWN: {
    title: '???'
  }
};

export const NEST_ITEM_IMAGES = {
  VETERAN: [
    VeteranLevel0,
    VeteranLevel1,
    VeteranLevel2,
    VeteranLevel3,
    VeteranLevel4,
    VeteranLevel5
  ],
  CONTRIBUTOR: [
    ContributorLevel0,
    ContributorLevel1,
    ContributorLevel2,
    ContributorLevel3,
    ContributorLevel4
  ],
  ALTRUIST: [
    AltruistLevel0,
    AltruistLevel1,
    AltruistLevel2,
    AltruistLevel3,
    AltruistLevel4,
    AltruistLevel5
  ],
  UNKNOWN: [SolidEgg]
};
